import React, { useState } from 'react'
import Lightbox from 'react-images'
import {
  Div, H5,
} from 'konsys-ui'
import Container from '../../components/container'
import {
  BgContainer, WidthContainer, ContentContianer,
} from './styled'
import Banner from '../../images/printing-information/banner.jpg'
import ppa11 from '../../images/printing-information/Papers/1-1_Art_Card_One_Page_01.jpg'
import ppa12 from '../../images/printing-information/Papers/1-1_Art_Card_One_Page_02.jpg'
import ppa21 from '../../images/printing-information/Papers/1-2_Art_Card_Two_Page_01.jpg'
import ppa22 from '../../images/printing-information/Papers/1-2_Art_Card_Two_Page_02.jpg'
import ppd11 from '../../images/printing-information/Papers/2-1_Duplex_Gray_01.jpg'
import ppd12 from '../../images/printing-information/Papers/2-1_Duplex_Gray_02.jpg'
import ppd21 from '../../images/printing-information/Papers/2-2_Duplex_White_01.jpg'
import ppd22 from '../../images/printing-information/Papers/2-2_Duplex_White_02.jpg'
import ppf1 from '../../images/printing-information/Papers/3_Foiled_01.jpg'
import ppf2 from '../../images/printing-information/Papers/3_Foiled_02.jpg'
import ppf3 from '../../images/printing-information/Papers/3_Foiled_03.jpg'
import ppf4 from '../../images/printing-information/Papers/3_Foiled_04.jpg'
import ppf5 from '../../images/printing-information/Papers/3_Foiled_05.jpg'
import ppf6 from '../../images/printing-information/Papers/3_Foiled_06.jpg'
import ppg1 from '../../images/printing-information/Papers/4_Grey_Board_01.jpg'
import ppg2 from '../../images/printing-information/Papers/4_Grey_Board_02.jpg'
import { ContentInfo } from '.'
import { theme } from '../../styles/_variables'

const allImage = [ppa11, ppa12, ppa21, ppa22, ppd11, ppd12, ppd21, ppd22, ppf1, ppf2, ppf3, ppf4, ppf5, ppf6, ppg1, ppg2]

const Paper = () => {
  const [openLightBox, setOpenLightBox] = useState(false)
  const [currentImage, setCurrentImage] = useState(0)

  return (
    <Container
      header={{
        type: 'title',
        img: Banner,
        title: 'ข้อมูลกระดาษ',
      }}
    >
      <Div>
        <BgContainer>
          <WidthContainer>
            <H5 color={theme.color.lightGrey}>ประเภทกระดาษที่นำมาใช้สำหรับผลิตกล่องบรรจุภัณฑ์มีดังนี้</H5>
            <ContentContianer>
              <ContentInfo
                title='1. กระดาษอาร์ตการ์ด (Art Card Paper)'
                content='คือ กระดาษที่มีลักษณะเนื้อแน่น ผิวเรียบมันวาว และมีความหนาแข็งแรงทนทานต่อแรงพับได้ดี สามารถแบ่งออกเป็น 2 ประเภท'
                openLightBox={(image) => {
                  setOpenLightBox(true)
                  setCurrentImage(image)
                }}
                subContent={[
                  {
                    title: '1.1 กระดาษอาร์ตการ์ดหน้าเดียว',
                    content: `คือ กระดาษการ์ดอาร์ตที่มีผิวด้านหน้าเรียบเป็นมันเงาผิวด้านหลังจะมีผิวด้านและหยาบเล็กน้อย
                     ทั้งนี้ก็เพื่อให้เกิดความแข็งแรงมากขึ้นในการรับน้ำหนักสินค้า กระดาษชนิดนี้จึงเหมาะสำหรับพิมพ์งานประเภทกล่องใส่เครื่องสำอาง
                     หรือกล่องบรรจุภัณฑ์ต่างๆที่ต้องการความแข็งแรง และยังให้ความสวยงามเป็นพิเศษ รวมถึงผิวสัมผัสของเนื้อกระดาษที่เรียบเนียนและให้สีดูสดใส`,
                    extra: [
                      {
                        bold: true,
                        light: true,
                        title: 'น้ำหนักกระดาษ :',
                        content: '210, 230, 250, 270, 300, 350, 400 แกรม',
                      },
                    ],
                    sample: [
                      { image: 0, src: ppa11 },
                      { image: 1, src: ppa12 },
                    ],
                  }, {
                    title: '1.2 กระดาษอาร์ตการ์ดสองหน้า',
                    content: 'คือ กระดาษการ์ดอาร์ตที่มีผิวเรียบมันเงาเหมือนกันทั้ง 2 ด้าน นิยมนำมาใช้พิมพ์กล่องบรรจุภัณฑ์ที่ต้องการพิมพ์ข้อความหรือลวดลายทั้งสองด้าน',
                    extra: [
                      {
                        bold: true,
                        light: true,
                        title: 'น้ำหนักกระดาษ :',
                        content: '190, 210, 230, 260, 310, 360 แกรม',
                      },
                    ],
                    sample: [
                      { image: 2, src: ppa21 },
                      { image: 3, src: ppa22 },
                    ],
                  },
                ]}
              />
              <ContentInfo
                title='2. กระดาษกล่องแป้ง (Duplex Board)'
                content={`คือ กระดาษที่ถูกผลิตมาจากเยื่อกระดาษที่ใช้แล้ว
                 นำมาบดผสมกับเยื่อกระดาษจึงทำให้มีสีคล้ำ กระดาษจะถูกประกบด้วยกระดาษขาวเคลือบผิวมัน 1 ด้านเพื่อใช้สำหรับการพิมพ์ สามารถแบ่งออกเป็น 2 ประเภท`}
                openLightBox={(image) => {
                  setOpenLightBox(true)
                  setCurrentImage(image)
                }}
                subContent={[
                  {
                    title: '2.1 กระดาษกล่องแป้งหน้าขาวหลังเทา (Gray Back Duplex Board)',
                    content: `คือ กระดาษกล่องแป้งที่มีด้านหนึ่งเรียบขาว ส่วนอีกด้านหนึ่งเป็นสีเทา
                     มีความแข็งแรงทนต่อการใช้งาน เหมาะสำหรับใช้ผลิตกล่องบรรจุภัณฑ์ต่างๆ อาทิ กล่องบรรจุอาหาร กล่องขนม กล่องของเล่น กล่องสบู่ ยาสีฟัน และพิมพ์โปสเตอร์ เป็นต้น`,
                    extra: [
                      {
                        bold: true,
                        light: true,
                        title: 'น้ำหนักกระดาษ :',
                        content: '270, 310, 350, 400, 450 แกรม',
                      },
                    ],
                    sample: [
                      { image: 4, src: ppd11 },
                      { image: 5, src: ppd12 },
                    ],
                  }, {
                    title: '2.2 กระดาษกล่องแป้งหน้าขาวหลังขาว (White Back Duplex Board)',
                    content: `คือ กระดาษกล่องแป้งที่มีสีขาวทั้งสองด้าน แต่ด้านหนึ่งจะเรียบขาวกว่าอีกด้านหนึ่ง
                     มีความแข็งแรงทนต่อการใช้งาน เหมาะสำหรับใช้ผลิตกล่องบรรจุภัณฑ์ที่ต้องการเน้นภาพลักษณ์ที่สะอาด โดดเด่น เช่น กล่องบรรจุอาหาร กล่องเครื่องสำอาง ยาเวชภัณฑ์ เป็นต้น`,
                    extra: [
                      {
                        bold: true,
                        light: true,
                        title: 'น้ำหนักกระดาษ :',
                        content: '270, 300, 350, 400, 450 แกรม',
                      },
                    ],
                    sample: [
                      { image: 6, src: ppd21 },
                      { image: 7, src: ppd22 },
                    ],
                  },
                ]}
              />
              <ContentInfo
                title='3. กระดาษฟอยล์ (Foiled Paper)'
                content={`คือ กระดาษอาร์ตการ์ดที่ถูกเคลือบด้วยฟอยล์ทั้งแผ่น ทำให้มีความเงาวาว
                 สะท้อนแสง ทั้งชิ้นงาน เพิ่มความสวยงาม และความโดดเด่นของชิ้นงานได้เป็นอย่างดี สีและลวดลายของกระดาษฟอยล์มีมากมายที่คุณสามารถเลือกนำมาใช้เป็นชิ้นงานของคุณ`}
                openLightBox={(image) => {
                  setOpenLightBox(true)
                  setCurrentImage(image)
                }}
                extra={[
                  {
                    bold: true,
                    light: true,
                    title: 'น้ำหนักกระดาษ :',
                    content: '300, 350 แกรม',
                  },
                ]}
                sample={[
                  { image: 8, src: ppf1 },
                  { image: 9, src: ppf2 },
                  { image: 10, src: ppf3 },
                  { image: 11, src: ppf4 },
                  { image: 12, src: ppf5 },
                  { image: 13, src: ppf6 },
                ]}
              />
              <ContentInfo
                title='4. กระดาษจั่วปัง หรือกระดาษแข็งสีเทา (Grey Board)'
                content={`คือ กระดาษแข็งสีเทาที่มีความแข็งแรง หนา และมีน้ำหนักมาก นิยมนำไปใช้เป็นโครงสร้างของกล่องบรรจุภัณฑ์แข็ง
                 เนื่องจากคุณสมบัติของกระดาษจั่วปังดังกล่าว กระดาษจั่วปังจึงไม่เหมาะสมในการนำมาพิมพ์ลวดลายต่างๆ
                 จึงมักถูกหุ้มติดด้วยกระดาษบางชั้นนอกที่ถูกพิมพ์ลวดลายแทน ชิ้นงานที่ผลิตจากกระดาษชนิดนี้จะมีความแข็งแรง
                 สวยหรูมากที่สุด แต่เนื่องจากความซับซ้อนในการผลิต ต้นทุนในการผลิตจึงสูงกว่ากระดาษชนิดอื่นๆมาก`}
                extra={[
                  {
                    bold: true,
                    light: true,
                    title: 'น้ำหนักกระดาษ :',
                    content: '430 (เบอร์ 8), 535 (เบอร์ 10), 642 (เบอร์ 12), 752 (เบอร์ 14), 845 (เบอร์ 16), 1110 (เบอร์ 20), 1324 (เบอร์ 24), 1544 (เบอร์ 28), 1730 (เบอร์ 32) แกรม',
                  }, {
                    bold: true,
                    light: true,
                    title: 'เบอร์อ้างอิง :',
                    content: '8, 10, 12, 14, 16, 20, 24, 28, 32',
                  },
                ]}
                sample={[
                  { image: 14, src: ppg1 },
                  { image: 15, src: ppg2 },
                ]}
                openLightBox={(image) => {
                  setOpenLightBox(true)
                  setCurrentImage(image)
                }}
              />
              <ContentInfo
                title='หน่วย "แกรม" คืออะไร'
                content={`คือหน่วย กรัม (gram) ของการชั่งมวลกระดาษที่มีพื้นที่ 1x1 ตารางเมตร
                 โดยกระดาษจะมีความหนามากขึ้น เมื่อมีแกรมมากขึ้น ยกตัวอย่างเช่น ขนาดกระดาษ 120 แกรมหมายถึงกระดาษที่มีน้ำหนัก 120 กรัม/ตารางเมตร`}
                extra={[
                  {
                    title: 'หมายเหตุ :',
                    content: 'เพื่อง่ายต่อการอ้างอิง กระดาษ A4 มีน้ำหนักระหว่าง 70-80 แกรม',
                  },
                ]}
                openLightBox={(image) => {
                  setOpenLightBox(true)
                  setCurrentImage(image)
                }}
              />
            </ContentContianer>
          </WidthContainer>
        </BgContainer>
        <Lightbox
          images={allImage.map(v => (
            { src: v }
          ))}
          currentImage={currentImage}
          isOpen={openLightBox}
          onClickNext={() => setCurrentImage(currentImage + 1)}
          onClickPrev={() => setCurrentImage(currentImage - 1)}
          onClose={() => setOpenLightBox(false)}
          backdropClosesModal={true}
        />
      </Div>
    </Container>
  )
}

export default Paper



// WEBPACK FOOTER //
// ./src/pages/printing-information/paper.jsx